module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "427px",
      "showClose": false
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading, center: true
    }
  }, [_c('h1', [_vm._v("Din reservation har gått ut")]), _vm._v(" "), _c('p', [_vm._v("Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.")]), _vm._v(" "), _c('table', [_c('thead'), _vm._v(" "), _c('tbody', [_vm._l((_vm.accomodations), function(accomodation, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(accomodation.name))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("dateRange")([accomodation.period.date_arrival, accomodation.period.date_departure], 'D MMMM', ' - ')) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((accomodation.quantity * accomodation.price))))])]), _vm._v(" "), (!accomodation.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          return _vm.reclaim('accomodation', accomodation, index)
        }
      }
    }, [_vm._v("Reservera")])]) : _vm._e(), _vm._v(" "), (accomodation.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("\n            Reserverad\n          ")]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.skischools), function(school, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(school.name))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("date")(school.date, 'D MMMM')) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((school.quantity * school.price))))])]), _vm._v(" "), (!school.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          return _vm.reclaim('skischool', school, index)
        }
      }
    }, [_vm._v("Reservera")])]) : _vm._e(), _vm._v(" "), (school.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("\n            Reserverad\n          ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), (!_vm.params.forceSyncAll) ? _c('div', [(_vm.params.continueToPayment && _vm.canContinue) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        _vm.closeModal();
        _vm.params.continueToPayment()
      }
    }
  }, [_vm._v("Fortsätt till betalning")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Stäng")])]) : _vm._e(), _vm._v(" "), (_vm.params.forceSyncAll) ? _c('div', [_c('button', {
    class: {
      small: true, border: true, disabled: !_vm.canContinueAll
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Fortsätt betalningen")]), _vm._v(" "), (!_vm.canContinueAll) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt betalning")]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05fc0e97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ReclaimReservationsModal.vue
// module id = 872
// module chunks = 0